// @dynamic-i18n-keys
// Dynamic t() at line 55: bodyKey from branch (monetizationPromo === 'tier' vs generic).
//   avatar.monetizationPromoStrip.var.tier.body
//   monetizationPromoStrip.var.generic.body
import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import {
  ThemeOptions,
  ThemeOverride,
} from '@wix/da-react-context/pkg/ThemeContext';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';

import s from './MonetizationPromoStrip.scss';

export interface Props {
  monetizationPromo: string;
  className?: string;
}

export const MonetizationPromoStrip: React.FC<Props> = ({
  monetizationPromo,
  className,
}) => {
  const { t } = useTranslation();
  if (
    ![
      'tier',
      'commission',
      'premium_gallery',
      'adoptable',
      'pcp',
      'generic',
    ].includes(monetizationPromo)
  ) {
    return null;
  }

  let bodyKey;
  let badgePromo = monetizationPromo;
  if (monetizationPromo === 'tier') {
    bodyKey = 'avatar.monetizationPromoStrip.var.tier.body';
  } else {
    bodyKey = 'monetizationPromoStrip.var.generic.body';
    badgePromo = 'generic';
  }

  return (
    <ThemeOverride theme={ThemeOptions.DARK}>
      <div className={classnames(s['root'], className)}>
        <PromoBadge
          badgeType={badgePromo as any}
          size={24}
          className={s['badge']}
        />
        <div className={s['text']}>{t(bodyKey)}</div>
      </div>
    </ThemeOverride>
  );
};
MonetizationPromoStrip.displayName = 'MonetizationPromoStrip';

export default MonetizationPromoStrip;
